import {registrationApi} from 'common/api/entitiesApi'
import * as React from 'react'
import {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import './style.css'
// import {TimezoneBean} from '../common/api/api';
import {Button, Form, Input, Layout, message} from 'antd';
import {UserOutlined, MailOutlined} from '@ant-design/icons';
import { useUserContext } from 'common/context/UserContext.tsx'
// import {formDataLoader, FormDataType, LoadInfo} from '../../util/FormDataLoader';

// const Option = Select.Option;
const FormItem = Form.Item

// const formInfoItems: FormDataType[] = [
//     FormDataType.TimeZones
// ];

export const SignUpForm: React.FC = () => {
    // const [info, setInfo] = useState({
    //     timezones: []
    // });
    const [form] = Form.useForm();
    const [isSuccess, setIsSuccess] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [error, setError] = useState<string | undefined>(undefined);
    const navigateTo = useNavigate()
    const [loading, setLoading] = useState(false)
    const { logoDataURI, customizationLoaded, agencyRecognized, advertiserSelfRegistration } = useUserContext()

    useEffect(() => {
        if (customizationLoaded && (!agencyRecognized || !advertiserSelfRegistration)) {
            navigateTo('/login', {replace: true})
        }
    }, [advertiserSelfRegistration, agencyRecognized, customizationLoaded, navigateTo])

    const handleSubmit = () => {
        setLoading(true)
        form.validateFields().then(formValues => {
            registrationApi.registerAdvertiser(formValues)
                .then(({success}) => {
                    if (success) {
                        setIsSuccess(true)
                        setLoading(false)
                        return
                    }
                    setError('Something went wrong, try again later')
                    setLoading(false)
                }).catch(() => {
                setLoading(false)
            })
        }).catch(() => setLoading(false))
    }

    // useEffect(() => {
    //         formDataLoader(...formInfoItems)
    //             .then((formInfo: LoadInfo) => {
    //                 setInfo(formInfo as any)
    //             })
    //             .catch(onrejected)
    // }, [])

    // let onrejected = (e: { error: React.SetStateAction<undefined> }) => {
    //     setError(e.error)
    // };

    const errorMessage = () => {
        messageApi.open({
            type: 'error',
            content: error,
            duration: 5,
            style: {
                marginTop: '80px',
            },
        });
    };

    useEffect(() => {
        if (error) {
            errorMessage()
            setError(undefined);
        }
    }, [error]);

    return isSuccess ? (
        <Layout>
            {contextHolder}
            {logoDataURI && (
                <div className="auth-logo-wrapper">
                    <img src={logoDataURI} alt="Logo" className="auth-logo" />
                </div>
            )}
            <Form
                className={'sign-up-form'}
                onFinish={handleSubmit}
                layout="vertical"
            >
                <div style={{display: 'flex', justifyContent: 'center'}}>We have sent a letter to your email address</div>
                <FormItem
                    style={{
                        marginTop: '20px'
                    }}
                >
                    <Button
                        style={{
                            width: '200px',
                            marginLeft: '100px'
                        }}
                        type="default"
                        htmlType="button"
                        onClick={() => navigateTo('/login')}
                    >
                        Go to Sign In
                    </Button>
                </FormItem>
            </Form>
        </Layout>
    ) : (
        <Layout>
            {contextHolder}
            {logoDataURI && (
                <div className="auth-logo-wrapper">
                    <img src={logoDataURI} alt="Logo" className="auth-logo" />
                </div>
            )}
            <Form
                className={'sign-up-form'}
                onFinish={handleSubmit}
                form={form}
                // labelCol={{span: 8}}
                // wrapperCol={{span: 16}}
                layout="vertical"
            >
                <FormItem
                    name="name"
                    rules={[{required: true, message: 'Please input Account name'}]}
                    // label="Name"
                >
                    <Input prefix={<UserOutlined style={{color: 'rgba(0,0,0,.25)'}}/>} placeholder="Name"/>
                </FormItem>
                <FormItem
                    name="email"
                    rules={[{required: true, message: 'Please input Account email'}]}
                    // label="Email"
                >
                    <Input prefix={<MailOutlined style={{color: 'rgba(0,0,0,.25)'}}/>} placeholder="Email"/>
                </FormItem>
                {/*<FormItem*/}
                {/*    name="timezoneId"*/}
                {/*    rules={[{required: true, message: 'Please select Time Zone', type: 'string'}]}*/}
                {/*    label="Time Zone"*/}
                {/*>*/}
                {/*    <Select*/}
                {/*        showSearch*/}
                {/*        placeholder="Select time zone">*/}
                {/*        {info.timezones.map((timezone: TimezoneBean) =>*/}
                {/*            <Option key={timezone.id} value={timezone.id as string}>{timezone.id}</Option>)}*/}
                {/*    </Select>*/}
                {/*</FormItem>*/}
                <FormItem style={{marginTop: '20px'}}>
                    <Button
                        style={{
                            width: '195px',
                        }}
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        disabled={loading}
                    >
                        Sign Up
                    </Button>
                    <Button style={{
                        width: '195px',
                        marginLeft: '10px'
                    }} type="default" htmlType="button" onClick={() => navigateTo('/login')}>Go to Sign In</Button>
                </FormItem>
            </Form>
        </Layout>
    )
}
